import styled from 'styled-components';

export const ChartContainer = styled.div`
width: 100%;
height: 400px;
position: relative;
  .header {
    display: flex;
    align-items: center;
    font-size: 17px !important;
    justify-content: center;
    font-weight: bold;
    margin-bottom: 20px;
    gap: 10px;
  }
  .title {
    font-size: 17px !important;    
    font-weight: bold;
    margin-right: 10px;
  }
 .basic {
  margin-left: 30px;
  width: calc(100% - 30px);
  margin-top: 20px;
 }
 .arrow-left {
  font-size: 2em !important;
  z-index: 10;
  cursor: pointer;
  i {
    background: white !important;
    padding-top: 5px !important;
    border-radius: 50% !important;
  }
 }
 .arrow-right {
  z-index: 10;
  font-size: 2em !important;
  cursor: pointer;
  i {
    background: white !important;
    padding-top: 5px !important;
    border-radius: 50% !important;
  }
 }
`
export const StyledHeader = styled.div`
display: flex;
align-items: baseline;
 .title {
  font-size: 21px !important;
 }
`

export const TooltipWrapper = styled.div`
margin: 0;
border: none !important;
background-color: #f7f9fd;
border-radius: 10px;
padding: 5px;
`